import React, { useState, useEffect } from "react";
import "./PuzzleSlider.css";

const emojiTiles = [
  "😀","🐶","🍎","⚽️","🚗","🎸","🌍","📚",
  "🐱","🦁","🍔","🎬","🐘","🐍","🦉","🎵",
  "🥕","🍕","🐼","🐧","🌞","🌈","🍩","🎂"
]; // enough emojis for 5x5

function shuffleArray(array) {
  let shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export default function PuzzleSlider() {
  const [difficulty, setDifficulty] = useState("easy");
  const [size, setSize] = useState(3);
  const [tiles, setTiles] = useState([]);
  const [message, setMessage] = useState("");
  const [moves, setMoves] = useState(0);

  // Sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  useEffect(() => {
    let count = difficulty === "easy" ? 8 : difficulty === "medium" ? 15 : 24;
    let gridSize = difficulty === "easy" ? 3 : difficulty === "medium" ? 4 : 5;
    setSize(gridSize);
    let shuffled = shuffleArray([...emojiTiles.slice(0, count), ""]);
    setTiles(shuffled);
    setMoves(0);
    setMessage("");
  }, [difficulty]);

  const moveTile = (index) => {
    const emptyIndex = tiles.indexOf("");
    const validMoves = [
      emptyIndex - 1,
      emptyIndex + 1,
      emptyIndex - size,
      emptyIndex + size,
    ];

    if (validMoves.includes(index)) {
      let newTiles = [...tiles];
      [newTiles[emptyIndex], newTiles[index]] = [newTiles[index], newTiles[emptyIndex]];
      setTiles(newTiles);
      setMoves(moves + 1);
      correctSound.play();

      if (checkWin(newTiles)) {
        setMessage("🎉 Puzzle Complete!");
        winSound.play();
      }
    } else {
      setMessage("❌ Invalid move!");
      wrongSound.play();
      setMoves(moves - 1);
    }
  };

  const checkWin = (tiles) => {
    let target = [...emojiTiles.slice(0, tiles.length - 1), ""];
    return JSON.stringify(tiles) === JSON.stringify(target);
  };

  return (
    <div className="puzzle-container">
      <h1>🧩 Puzzle Slider</h1>
      <div className="mode-buttons">
        <button onClick={() => setDifficulty("easy")}>Easy (3×3)</button>
        <button onClick={() => setDifficulty("medium")}>Medium (4×4)</button>
        <button onClick={() => setDifficulty("hard")}>Hard (5×5)</button>
      </div>
      <p>⭐ Moves: {moves}</p>
      <p className="status">{message}</p>

      <div className="puzzle-grid" style={{gridTemplateColumns: `repeat(${size}, 1fr)`}}>
        {tiles.map((tile, index) => (
          <div
            key={index}
            className={`puzzle-cell ${tile === "" ? "empty" : ""}`}
            onClick={() => moveTile(index)}
            onTouchStart={() => moveTile(index)}   
          >
            {tile}
          </div>
        ))}
      </div>
    </div>
  );
}
